// Phase 24B — Visit report
import TransactionReportPage from "./TransactionReportPage";

export default function VisitReport() {
  return (
    <TransactionReportPage
      slug="visit"
      testidPrefix="visit-report"
      title="Visit Report"
      subtitle="Field visits with productive/PJP flags, order capture indicators, GPS."
      initialDaysBack={30}
      filterConfig={{ showUser: true, showDistributor: true }}
    />
  );
}
